/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --cursor: pointer;
  --width: var(--nve-ref-size-400);
  --height: var(--nve-ref-size-400);
  --border-width: var(--nve-ref-border-width-md);
  --border-radius: var(--nve-ref-border-radius-full);
  --border-color: var(--nve-ref-border-color);
  --radio-color: var(--border-color);
  --background: transparent;
  display: inline-block;
  contain: layout;
  will-change: transform, border-color;
}

::slotted(input) {
  width: var(--width) !important;
  height: var(--height) !important;
  cursor: var(--cursor) !important;
  margin: 0 !important;
  position: absolute !important;
  border-radius: var(--border-radius) !important;
  opacity: 0 !important;
  inset: 0 !important;
}

[input] {
  align-items: center;
  position: relative;
}

@keyframes radio-select-pop {
  0% {
    transform: scale(0.8);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

[input] slot {
  width: var(--width);
  height: var(--height);
  border: var(--border-width) solid var(--border-color);
  background: var(--background);
  border-radius: var(--border-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    transform var(--nve-ref-animation-duration-200) cubic-bezier(0.12, 0.32, 0.54, 2),
    border-color var(--nve-ref-animation-duration-150) ease;
  will-change: transform, border-color;
}

[input] slot::before {
  content: '';
  width: calc(var(--width) / 2);
  height: calc(var(--height) / 2);
  border-radius: var(--border-radius);
  transform: scale(0);
  opacity: 0;
  transition:
    transform var(--nve-ref-animation-duration-250) ease,
    opacity var(--nve-ref-animation-duration-200) ease,
    background-color var(--nve-ref-animation-duration-150) ease;
}

:host(:state(checked):state(dirty)) [input] slot {
  animation: radio-select-pop var(--nve-ref-animation-duration-200) ease-out;
}

:host(:state(checked)) [input] slot::before {
  background: var(--radio-color);
  transform: scale(1);
  opacity: 1;
}

:host(:state(checked)) {
  --border-color: var(--accent-color);
}

:host(:state(disabled)) {
  --border-color: var(--nve-sys-interaction-disabled-background);
}
